import { useReaction } from '@speedlo/hooks'

import { useRoot } from '../../../app/useRoot'
import { useQFoodMenu } from '../../../graph/generated'

export function useFoodMenuQuery(branchId: MaybeID) {
  const { user } = useRoot()
  const result = useQFoodMenu(
    { branchId: branchId! },
    { skip: !branchId, fetchPolicy: 'cache-first' },
  )

  useReaction(
    () => user.language,
    () => {
      result.refetch()
    },
  )

  return result
}
